import React, { useRef } from 'react'
import { FormGroup, Label, Input, Button } from "reactstrap";
import { formOptions } from "./constants";
import { FaLocationArrow, FaFilePdf, FaImage } from "react-icons/fa";
import CoordinateMapsVerifikasi from './CoordinateMapsVerifikasi';

const Penilaian = ({
  fotoSuratKepemilikanTanah,
  setFotoSuratKepemilikanTanah,
  imagePreviewSuratKepemilikanTanah,
  setImagePreviewSuratKepemilikanTanah,
  isPreviewingSuratKepemilikanTanah,
  setIsPreviewingSuratKepemilikanTanah,
  // Props untuk foto rumah saat ini
  fotoRumahSaatIni,
  setFotoRumahSaatIni,
  imagePreviewRumahSaatIni,
  setImagePreviewRumahSaatIni,
  isPreviewingRumahSaatIni,
  setIsPreviewingRumahSaatIni,
  formData, 
  handleChange,
  handleGetCoordinates,  
  errors,
  requiredCoordinateKecamatan = []
}) => {
  const videoRefSurat = useRef(null);
  const videoRefRumahSaatIni = useRef(null);
   const activeCoordinate = formData.titikKoordinatRumah || formData.manualTitikKoordinatRumah || "";
  // ============ FUNGSI UNTUK SURAT KEPEMILIKAN TANAH ============
  const startPreviewSurat = async () => {
    try {
      setIsPreviewingSuratKepemilikanTanah(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }
      });
      videoRefSurat.current.srcObject = stream;
      await videoRefSurat.current.play();
    } catch (error) {
      console.error("Error accessing camera:", error);
      setIsPreviewingSuratKepemilikanTanah(false);
      alert("Tidak dapat mengakses kamera. Pastikan browser memiliki izin kamera.");
    }
  };
 const handleMapCoordinateChange = (coordString) => {
    // Simulate a change event for manualTitikKoordinatRumah
    const syntheticEvent = {
      target: {
        name: "manualTitikKoordinatRumah",
        value: coordString,
      },
    };
    handleChange(syntheticEvent);
  };
  const capturePhotoSurat = async () => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = videoRefSurat.current.videoWidth;
      canvas.height = videoRefSurat.current.videoHeight;
      canvas.getContext("2d").drawImage(videoRefSurat.current, 0, 0);
      const dataUrl = canvas.toDataURL("image/png");
      const blob = await fetch(dataUrl).then((res) => res.blob());
      
      setFotoSuratKepemilikanTanah(new File([blob], "surat-kepemilikan-tanah.png", { type: "image/png" }));
      setImagePreviewSuratKepemilikanTanah(dataUrl);
      
      if (videoRefSurat.current.srcObject) {
        videoRefSurat.current.srcObject.getTracks().forEach((track) => track.stop());
      }
      setIsPreviewingSuratKepemilikanTanah(false);
    } catch (error) {
      console.error("Error capturing photo:", error);
      alert("Gagal mengambil foto. Silakan coba lagi.");
    }
  };

  const cancelPreviewSurat = async () => {
    setImagePreviewSuratKepemilikanTanah(null);
    setFotoSuratKepemilikanTanah(null);
    if (isPreviewingSuratKepemilikanTanah && videoRefSurat.current && videoRefSurat.current.srcObject) {
      videoRefSurat.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    setIsPreviewingSuratKepemilikanTanah(false);
  };

  const handleFileChangeSurat = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        alert('Harap pilih file gambar (JPEG, PNG, GIF) atau PDF yang valid');
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        alert('Ukuran file maksimal 5MB');
        return;
      }

      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          setImagePreviewSuratKepemilikanTanah(reader.result);
          setFotoSuratKepemilikanTanah(file);
        };
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        setImagePreviewSuratKepemilikanTanah(null);
        setFotoSuratKepemilikanTanah(file);
      }
    }
  };

  const openFilePickerSurat = () => {
    const fileInput = document.getElementById("fotoSuratKepemilikanTanah");
    if (fileInput) {
      fileInput.click();
    }
  };

  // ============ FUNGSI UNTUK FOTO RUMAH SAAT INI ============
  const startPreviewRumahSaatIni = async () => {
    try {
      setIsPreviewingRumahSaatIni(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }
      });
      videoRefRumahSaatIni.current.srcObject = stream;
      await videoRefRumahSaatIni.current.play();
    } catch (error) {
      console.error("Error accessing camera:", error);
      setIsPreviewingRumahSaatIni(false);
      alert("Tidak dapat mengakses kamera. Pastikan browser memiliki izin kamera.");
    }
  };

  const capturePhotoRumahSaatIni = async () => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = videoRefRumahSaatIni.current.videoWidth;
      canvas.height = videoRefRumahSaatIni.current.videoHeight;
      canvas.getContext("2d").drawImage(videoRefRumahSaatIni.current, 0, 0);
      const dataUrl = canvas.toDataURL("image/png");
      const blob = await fetch(dataUrl).then((res) => res.blob());
      
      setFotoRumahSaatIni(new File([blob], "foto-rumah-saat-ini.png", { type: "image/png" }));
      setImagePreviewRumahSaatIni(dataUrl);
      
      if (videoRefRumahSaatIni.current.srcObject) {
        videoRefRumahSaatIni.current.srcObject.getTracks().forEach((track) => track.stop());
      }
      setIsPreviewingRumahSaatIni(false);
    } catch (error) {
      console.error("Error capturing photo:", error);
      alert("Gagal mengambil foto. Silakan coba lagi.");
    }
  };

  const cancelPreviewRumahSaatIni = async () => {
    setImagePreviewRumahSaatIni(null);
    setFotoRumahSaatIni(null);
    if (isPreviewingRumahSaatIni && videoRefRumahSaatIni.current && videoRefRumahSaatIni.current.srcObject) {
      videoRefRumahSaatIni.current.srcObject.getTracks().forEach((track) => track.stop());
    }
    setIsPreviewingRumahSaatIni(false);
  };

  const handleFileChangeRumahSaatIni = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        alert('Harap pilih file gambar (JPEG, PNG, GIF) yang valid');
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        alert('Ukuran file maksimal 5MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setImagePreviewRumahSaatIni(reader.result);
        setFotoRumahSaatIni(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const openFilePickerRumahSaatIni = () => {
    const fileInput = document.getElementById("fotoRumahSaatIni");
    if (fileInput) {
      fileInput.click();
    }
  };

  // ============ UTILITY FUNCTIONS ============
  const handleStatusKepemilikanChange = (e) => {
    const { value } = e.target;
    
    if (value !== "Lainnya" && formData.StatusKepemilikanTanah === "Lainnya") {
      handleChange({
        target: {
          name: "StatusKepemilikanTanahLainnya",
          value: ""
        }
      });
    }
    
    handleChange(e);
  };

  const getFileName = (file) => {
    if (!file) return null;
    return file.name;
  };

  const getFileType = (file) => {
    if (!file) return null;
    return file.type;
  };

  const renderPreviewSurat = () => {
    if (!fotoSuratKepemilikanTanah) return null;

    const fileType = getFileType(fotoSuratKepemilikanTanah);
    
    if (fileType.startsWith('image/') && imagePreviewSuratKepemilikanTanah) {
      return (
        <div className="mt-3">
          <p className="text-success">
            <strong>✓ Surat kepemilikan tanah sudah dipilih (Gambar)</strong>
          </p>
          <img 
            src={imagePreviewSuratKepemilikanTanah} 
            alt="Preview Surat Kepemilikan Tanah" 
            style={{ 
              width: "100%", 
              maxHeight: "300px", 
              objectFit: "contain",
              border: "1px solid #ddd",
              borderRadius: "4px"
            }} 
          />
        </div>
      );
    } else if (fileType === 'application/pdf') {
      return (
        <div className="mt-3">
          <p className="text-success">
            <strong>✓ Surat kepemilikan tanah sudah dipilih (PDF)</strong>
          </p>
          <div 
            style={{ 
              padding: "20px",
              border: "2px dashed #ddd",
              borderRadius: "4px",
              textAlign: "center",
              backgroundColor: "#f8f9fa"
            }}
          >
            <FaFilePdf size={50} color="#dc3545" />
            <div className="mt-2">
              <strong>{getFileName(fotoSuratKepemilikanTanah)}</strong>
            </div>
            <div className="text-muted">
              File PDF siap diupload
            </div>
          </div>
        </div>
      );
    }
    
    return null;
  };

  const renderPreviewRumahSaatIni = () => {
    if (!fotoRumahSaatIni || !imagePreviewRumahSaatIni) return null;

    return (
      <div className="mt-3">
        <p className="text-success">
          <strong>✓ Foto rumah saat ini sudah dipilih</strong>
        </p>
        <img 
          src={imagePreviewRumahSaatIni} 
          alt="Preview Foto Rumah Saat Ini" 
          style={{ 
            width: "100%", 
            maxHeight: "300px", 
            objectFit: "contain",
            border: "1px solid #ddd",
            borderRadius: "4px"
          }} 
        />
      </div>
    );
  };

  const isTanahMilikSendiri = formData.StatusKepemilikanTanah === "Milik Sendiri,Ada dokumen sah";
  const isLainnya = formData.StatusKepemilikanTanah === "Lainnya";

  return (
    <>
      <FormGroup>
        <Label for="rumahTinggalSendiri">7. Rumah Tinggal Sendiri</Label>
        <Input
          type="select"
          name="rumahTinggalSendiri"
          id="rumahTinggalSendiri"
          value={formData.rumahTinggalSendiri}
          onChange={handleChange}
          className={errors.rumahTinggalSendiri ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.rumahTinggalSendiri.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.rumahTinggalSendiri && <div className="invalid-feedback">{errors.rumahTinggalSendiri}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="statusKeluarga">8. Status Keluarga</Label>
        <Input
          type="select"
          name="statusKeluarga"
          id="statusKeluarga"
          value={formData.statusKeluarga}
          onChange={handleChange}
          className={errors.statusKeluarga ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.statusKeluarga.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.statusKeluarga && <div className="invalid-feedback">{errors.statusKeluarga}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="usiaPernikahan">9. Usia Pernikahan</Label>
        <Input
          type="select"
          name="usiaPernikahan"
          id="usiaPernikahan"
          value={formData.usiaPernikahan}
          onChange={handleChange}
          className={errors.usiaPernikahan ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.usiaPernikahan.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.usiaPernikahan && <div className="invalid-feedback">{errors.usiaPernikahan}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="StatusKepemilikanTanah">10. Status Kepemilikan Tanah</Label>
        <Input
          type="select"
          name="StatusKepemilikanTanah"
          id="StatusKepemilikanTanah"
          value={formData.StatusKepemilikanTanah}
          onChange={handleStatusKepemilikanChange}
          className={errors.StatusKepemilikanTanah ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.StatusKepemilikanTanah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
          <option value="Lainnya">Lainnya (tulis manual)</option>
        </Input>
        {errors.StatusKepemilikanTanah && <div className="invalid-feedback">{errors.StatusKepemilikanTanah}</div>}
      </FormGroup>

      {isLainnya && (
        <FormGroup>
          <Label for="StatusKepemilikanTanahLainnya" className="text-primary">
            * Tulis Status Kepemilikan Tanah
          </Label>
          <Input
            type="text"
            name="StatusKepemilikanTanahLainnya"
            id="StatusKepemilikanTanahLainnya"
            value={formData.StatusKepemilikanTanahLainnya || ""}
            onChange={handleChange}
            placeholder="Contoh: Sewa, Hibah, Wakaf, dll."
            className={errors.StatusKepemilikanTanahLainnya ? "is-invalid" : ""}
          />
          {errors.StatusKepemilikanTanahLainnya && (
            <div className="invalid-feedback">{errors.StatusKepemilikanTanahLainnya}</div>
          )}
          <small className="form-text text-muted">
            Tulis status kepemilikan tanah lainnya yang tidak tersedia di opsi di atas
          </small>
        </FormGroup>
      )}

  
      {/* UPLOAD DOKUMEN SURAT KEPEMILIKAN (WAJIB JIKA MILIK SENDIRI) */}
      {isTanahMilikSendiri && (
        <FormGroup>
          <Label for="fotoSuratKepemilikanTanah" className="text-danger">
            * Upload Surat Kepemilikan Tanah (Wajib)
          </Label>
          
          <Input 
            type="file" 
            name="fotoSuratKepemilikanTanah" 
            id="fotoSuratKepemilikanTanah" 
            accept="image/*,.pdf,.PDF" 
            onChange={handleFileChangeSurat}
            style={{ display: "none" }}
          />

          {isPreviewingSuratKepemilikanTanah ? (
            <div>
              <video 
                ref={videoRefSurat} 
                style={{ 
                  width: "100%", 
                  height: "auto", 
                  maxHeight: "300px",
                  border: "1px solid #ddd",
                  borderRadius: "4px"
                }} 
                autoPlay 
                playsInline
              />
              <div className="d-flex gap-2 mt-2">
                <Button className="btn btn-success" onClick={capturePhotoSurat}>
                  📷 Ambil Foto
                </Button>
                <Button className="btn btn-outline-secondary" onClick={cancelPreviewSurat}>
                  ❌ Batalkan
                </Button>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column gap-2">
              <div className="d-flex gap-2">
                <Button 
                  className="btn btn-primary mt-2 flex-fill" 
                  onClick={startPreviewSurat}
                >
                  <FaImage className="me-2" />
                  Gunakan Kamera
                </Button>
                <Button 
                  className="btn btn-secondary mt-2 flex-fill"   
                  onClick={openFilePickerSurat}
                >
                  <FaFilePdf className="me-2" />
                 📁 Pilih File
                </Button>
              </div>
              
              {fotoSuratKepemilikanTanah && (
                <div className="alert alert-info mt-2 py-2">
                  <small>
                    <strong>File terpilih:</strong> {getFileName(fotoSuratKepemilikanTanah)} 
                    ({getFileType(fotoSuratKepemilikanTanah) === 'application/pdf' ? 'PDF' : 'Gambar'})
                  </small>
                </div>
              )}
            </div>
          )}

          {renderPreviewSurat()}

          {fotoSuratKepemilikanTanah && !isPreviewingSuratKepemilikanTanah && (
            <Button className="btn btn-danger mt-2" onClick={cancelPreviewSurat}>
              Hapus File
            </Button>
          )}

          {!fotoSuratKepemilikanTanah && !isPreviewingSuratKepemilikanTanah && (
            <small className="form-text text-danger">
              <strong>
                Wajib upload dokumen surat kepemilikan tanah (SHM, SHGB, Girik, dll.)<br />
                Format: JPG, PNG, GIF, atau PDF - Maksimal 5MB
              </strong>
            </small>
          )}

          {isTanahMilikSendiri && !fotoSuratKepemilikanTanah && errors.fotoSuratKepemilikanTanah && (
            <div className="text-danger small mt-1">
              {errors.fotoSuratKepemilikanTanah}
            </div>
          )}
        </FormGroup>
      )}

      <FormGroup>
        <Label for="apakahLokasiTanahSesuaiRTRW">11. Apakah Lokasi Tanah Sesuai RTRW</Label>
        <Input
          type="select"
          name="apakahLokasiTanahSesuaiRTRW"
          id="apakahLokasiTanahSesuaiRTRW"
          value={formData.apakahLokasiTanahSesuaiRTRW}
          onChange={handleChange}
          className={errors.apakahLokasiTanahSesuaiRTRW ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.apakahLokasiTanahSesuaiRTRW.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.apakahLokasiTanahSesuaiRTRW && <div className="invalid-feedback">{errors.apakahLokasiTanahSesuaiRTRW}</div>}
      </FormGroup>
      
      <FormGroup>
        <Label for="tingkatPenghasilanKeluarga">12. Tingkat Penghasilan Keluarga</Label>
        <Input
          type="select"
          name="tingkatPenghasilanKeluarga"
          id="tingkatPenghasilanKeluarga"
          value={formData.tingkatPenghasilanKeluarga}
          onChange={handleChange}
          className={errors.tingkatPenghasilanKeluarga ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.tingkatPenghasilanKeluarga.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.tingkatPenghasilanKeluarga && <div className="invalid-feedback">{errors.tingkatPenghasilanKeluarga}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="jumlahPenghuniRumah">13. Jumlah Penghuni Rumah</Label>
        <Input
          type="number"
          name="jumlahPenghuniRumah"
          id="jumlahPenghuniRumah"
          value={formData.jumlahPenghuniRumah}
          onChange={handleChange}
          className={errors.jumlahPenghuniRumah ? "is-invalid" : ""}   
        />
        {errors.jumlahPenghuniRumah && <div className="invalid-feedback">{errors.jumlahPenghuniRumah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="namaSurveyor">14. Nama Surveyor</Label>
        <Input 
          type="text" 
          name="namaSurveyor" 
          id="namaSurveyor" 
          value={formData.namaSurveyor} 
          readOnly 
        />
        {errors.namaSurveyor && <div className="invalid-feedback">{errors.namaSurveyor}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="titikKoordinatRumah">15. Koordinat</Label>
        <Input 
          type="text" 
          name="titikKoordinatRumah" 
          id="titikKoordinatRumah" 
          value={formData.titikKoordinatRumah} 
          readOnly 
        />
        <Button color="primary" onClick={handleGetCoordinates} className="btn-get-coordinates mt-2">
          <FaLocationArrow /> Ambil Koordinat
        </Button>
        {errors.titikKoordinatRumah && <div className="invalid-feedback">{errors.titikKoordinatRumah}</div>}
      </FormGroup>
 <FormGroup>
        <Label for="manualTitikKoordinatRumah">Atau Masukkan Koordinat Manual</Label>
        <Input
          type="text"
          name="manualTitikKoordinatRumah"
          id="manualTitikKoordinatRumah"
          value={formData.manualTitikKoordinatRumah || ""}
          onChange={handleChange}
          invalid={!!errors.manualTitikKoordinatRumah}
          className="form-input"
          placeholder="Contoh: -8.512345, 117.012345"
          disabled={requiredCoordinateKecamatan.includes(formData.kecamatan)} // Disable jika kecamatan termasuk Maluk/Jereweh
        />
        {errors.manualTitikKoordinatRumah && (
          <div className="invalid-feedback">{errors.manualTitikKoordinatRumah}</div>
        )}
      </FormGroup>

      {/* Leaflet Satellite Map with Draggable Marker */}
      <CoordinateMapsVerifikasi
        coordinates={activeCoordinate}
        onCoordinateChange={handleMapCoordinateChange}
      />
      {/* <FormGroup>
        <Label for="manualTitikKoordinatRumah">Manual Koordinat</Label>
        <Input 
          type="text" 
          name="manualTitikKoordinatRumah" 
          id="manualTitikKoordinatRumah" 
          value={formData.manualTitikKoordinatRumah} 
          onChange={handleChange}
        />
        {errors.manualTitikKoordinatRumah && <div className="invalid-feedback">{errors.manualTitikKoordinatRumah}</div>}
      </FormGroup> */}
          {/* UPLOAD FOTO RUMAH SAAT INI (OPSIONAL) */}
      <FormGroup>
        <Label for="fotoRumahSaatIni" className="text-info">
          Foto Rumah Saat Ini (Opsional)
        </Label>
        
        <Input 
          type="file" 
          name="fotoRumahSaatIni" 
          id="fotoRumahSaatIni" 
          accept="image/*" 
          onChange={handleFileChangeRumahSaatIni}
          style={{ display: "none" }}
        />

        {isPreviewingRumahSaatIni ? (
          <div>
            <video 
              ref={videoRefRumahSaatIni} 
              style={{ 
                width: "100%", 
                height: "auto", 
                maxHeight: "300px",
                border: "1px solid #ddd",
                borderRadius: "4px"
              }} 
              autoPlay 
              playsInline
            />
            <div className="d-flex gap-2 mt-2">
              <Button className="btn btn-success" onClick={capturePhotoRumahSaatIni}>
                📷 Ambil Foto
              </Button>
              <Button className="btn btn-outline-secondary" onClick={cancelPreviewRumahSaatIni}>
                ❌ Batalkan
              </Button>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-2">
            <div className="d-flex gap-2">
              <Button 
                className="btn btn-primary mt-2 flex-fill" 
                onClick={startPreviewRumahSaatIni}
              >
                <FaImage className="me-2" />
                Gunakan Kamera
              </Button>
              <Button 
                className="btn btn-secondary mt-2 flex-fill"   
                onClick={openFilePickerRumahSaatIni}
              >
                📁 Pilih File
              </Button>
            </div>
            
            {fotoRumahSaatIni && (
              <div className="alert alert-info mt-2 py-2">
                <small>
                  <strong>File terpilih:</strong> {getFileName(fotoRumahSaatIni)}
                </small>
              </div>
            )}
          </div>
        )}

        {renderPreviewRumahSaatIni()}

        {fotoRumahSaatIni && !isPreviewingRumahSaatIni && (
          <Button className="btn btn-warning mt-2" onClick={cancelPreviewRumahSaatIni}>
            Hapus Foto
          </Button>
        )}

        <small className="form-text text-muted">
          Upload foto kondisi rumah saat ini
        </small>
      </FormGroup>

    </>
  )
}

export default Penilaian